export default [
  {
    path: '/metaplanet_LtbDeposit',
    name: 'LtbDepositView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-log" */ '@/views/MetaplanetLog/LtbDepositView.vue'
      ),
    meta: { title: 'LTB Deposit', group: 'metaplanet-log' },
  },
  {
    path: '/metaplanet_LtbSwap',
    name: 'LtbSwapView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-log" */ '@/views/MetaplanetLog/LtbSwapView.vue'
      ),
    meta: { title: 'LTB Swap', group: 'metaplanet-log' },
  },
  {
    path: '/metaplanet_LtbTransferMetaq',
    name: 'LtbTransferMetaqView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-log" */ '@/views/MetaplanetLog/LtbTransferMetaqView.vue'
      ),
    meta: { title: 'LTB Transfer Metaq', group: 'metaplanet-log' },
  },
  {
    path: '/metaplanet_LtbWithdraw',
    name: 'LtbWithdrawView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-log" */ '@/views/MetaplanetLog/LtbWithdrawView.vue'
      ),
    meta: { title: 'LTB Withdraw', group: 'metaplanet-log' },
  },
  {
    path: '/metaplanet_LtbMetaq',
    name: 'LtbMetaqView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-log" */ '@/views/MetaplanetLog/LtbMetaqView.vue'
      ),
    meta: { title: 'LTB Metaq', group: 'metaplanet-log' },
  },
  {
    path: '/metaplanet_LtbNftStaking',
    name: 'LtbNftStakingView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-log" */ '@/views/MetaplanetLog/LtbNftStakingView.vue'
      ),
    meta: { title: 'LTB NFT Staking', group: 'metaplanet-log' },
  },
  {
    path: '/metaplanet_LtbTokens',
    name: 'LtbTokensView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-log" */ '@/views/MetaplanetLog/LtbTokensView.vue'
      ),
    meta: { title: 'LTB Tokens', group: 'metaplanet-log' },
  },
  {
    path: '/metaplanet_LtbTransferNft',
    name: 'LtbTransferNftView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet-log" */ '@/views/MetaplanetLog/LtbTransferNftView.vue'
      ),
    meta: { title: 'LTB Transfer NFT', group: 'metaplanet-log' },
  },
]
